// extracted by mini-css-extract-plugin
export var internalNoteEditor = "_j2-1";
export var quotedThread = "_j2-0";